import styled, { keyframes } from 'styled-components';
import { FlexCard, FlexCardProps } from '../Card';

const fadeIn = keyframes`
  0% { transform: translate(0, -25%); }
  100% { transform: translate(0, 0); }
`;
const fadeRight = keyframes`
  0% { transform: translate(25%, 0);
    opacity: 0.25;
  
  }
  100% { transform: translate(0, 0);
    opacity: 1;
  }
`;

const fadeRightReverse = keyframes`
  0% { transform: translate(0, 0);
  opacity: 1;
  }
  100% { transform: translate(25%, 0); 
    opacity: 0.25;
  
  }
`;

export const StyledModalContainer = styled.div`
  position: fixed;
  z-index: 9000;
  left: 0;
  right: 0%;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);

  &.transition-translate-x-exit.transition-translate-x-exit-active > div {
    animation: ${fadeRightReverse} 0.5s ease-out !important;
  }
`;

export type StyledModalCardProps = FlexCardProps;

export const StyledModalCard = styled(FlexCard)`
  position: relative;
  flex-direction: column;
  max-width: 600px;
  animation: ${({ slideRight }) => (slideRight ? fadeRight : fadeIn)} 0.5s ease-out;
`;

StyledModalCard.defaultProps = {
  my: 'auto',
  mx: { xs: 10, sm: 20 },
  py: 40,
  px: { xs: 10, sm: 20, md: 30, lg: 40 },
  width: { xs: 'calc(100% - 20px)', sm: 'calc(100% - 40px)' },
  bg: 'white',
  boxShadow: 'shadow1'
};
